<template>
	<div>
		<form-sidebar>
			<v-form>
				<v-layout wrap>
					<v-flex xs12 sm6 md6 lg6>
						<v-text-field
							class="filter-select shadow-inset"
							placeholder="UserId"
							required
							single-line
							v-model="$v.model.userId.$model"
							:error="$v.model.userId.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 sm6 md6 lg6>
						<v-text-field
							class="filter-select shadow-inset"
							placeholder="Completo?"
							required
							single-line
							v-model="$v.model.completed.$model"
							:error="$v.model.completed.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 sm6 md6 lg6>
						<v-text-field
							class="filter-select shadow-inset"
							placeholder="Título"
							required
							single-line
							v-model="$v.model.title.$model"
							:error="$v.model.title.$error"
						>
						</v-text-field>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading="$v.$invalid || loading"
						:on-run-service="loading"
						@accept-button-clicked="submitForm"
						@cancel-button-clicked="closeModal"
					/>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

const PAGE_TODO_LIST = 'page-todo';

function data() {
	return {
		countries: [],
		loading: false,
		model: {
			userId: null,
			completed: false,
			title: '',
		},
	};
}

async function created() {
	if (this.mode === 'edit') {
		const { data: record } = await this.$httpMock.get(`todos/${this.todoId}`);
		if (record) {
			this.model = {
				userId: record.userId,
				completed: record.completed,
				title: record.title,
			};
		}
	}
}

function closeModal() {
	this.goTo(PAGE_TODO_LIST);
}

function mode() {
	return this.todoId ? 'edit' : 'create';
}

async function submitForm() {
	const method = this.mode === 'create' ? 'post' : 'patch';
	const url = this.mode === 'create' ? 'todos' : `todos/${this.todoId}`;
	this.loading = true;
	try {
		await this.$httpMock[method](url, this.model);
		this.goTo(PAGE_TODO_LIST);
	} finally {
		this.loading = false;
	}
}

function validations() {
	const validation = {
		model: {
			userId: {
				required,
			},
			completed: {
				required,
			},
			title: {
				required,
			},
		},
	};
	return validation;
}

export default {
	name: 'todos-form',
	created,
	computed: {
		mode,
	},
	data,
	methods: {
		closeModal,
		submitForm,
	},
	props: {
		todoId: {
			type: [Number, String],
		},
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/components/todos/todo-form.vue